<template>
  <section class="container-sarah">
    <breadcrumb route="/inicio" :title="this.$t('areas.home')" />
    <!-- Intro Text -->
    <div class="hero">
      <div class="hero-body">
        <h1 class="title">
          {{ $t('agenda.titulo') }}
        </h1>
        <p class="info_subtitle">
          {{ $t('agenda.subtitulo') }}
        </p>
      </div>
    </div>
    <!-- table of content -->
    <div class="table">
      <div
        v-if="ListaAgendamentos.length === 0"
        class="container-sarah no-data"
      >
        <div class="img-container">
          <img
            src="~@/assets/images/banners/doctors_calendar.svg"
            alt="Agenda"
          />
        </div>
        <h1 class="title">
          {{ $t('agenda.sem-agenda.titulo') }}
        </h1>
        <h2 class="subtitle">
          {{ $t('agenda.sem-agenda.subtitulo') }}
        </h2>
      </div>
      <div v-else>
        <b-table
          :data="ListaAgendamentos"
          :loading="isLoading"
          :paginated="isPaginated"
          :checkable="true"
          :checked-rows.sync="atendimentosSelecionados"
          :is-row-checkable="
            (row) =>
              row.Agendamento.FormaAtendimento ===
                FormaAtendimento.Presencial &&
              row.Agendamento.CodigoAtendimento > 0 &&
              podeConfirmarAgendamento([row])
          "
          :current-page.sync="currentPage"
          :per-page="perPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :aria-page-label="this.$t('tabelas.pagina')"
          :aria-current-label="this.$t('tabelas.pagina-atual')"
        >
          <template slot-scope="columns">
            <b-table-column field="DataVaga" label="Data">
              {{ columns.row.Agendamento.DataVaga }} -
              {{ diaDaSemana[new Date(columns.row.Agendamento.Data).getDay()] }}
            </b-table-column>
            <b-table-column field="Hora" label="Hora">
              {{ columns.row.Agendamento.Hora }}
            </b-table-column>
            <b-table-column field="Descricao" label="Descrição">
              {{ columns.row.Agendamento.Descricao }} -
              {{ textoObservacao(columns.row.Agendamento.FormaAtendimento) }}
            </b-table-column>
            <b-table-column
              :class="{ 'is-hidden-mobile': !getTags(columns.row)?.length }"
            >
              <b-tag
                v-for="(value, k) in getTags(columns.row)"
                :key="k"
                :type="value.type"
              >
                {{ value.label }}
              </b-tag>
            </b-table-column>
            <b-table-column field="Unidade" label="Unidade">
              {{ columns.row.Agendamento.Unidade }}
            </b-table-column>
            <b-table-column
              field="Local"
              label="Local"
              :visible="exibirColunaLocal"
            >
              <template v-if="!!columns.row.Agendamento.LocalChamadaAudio">
                {{ columns.row.Agendamento.LocalChamadaAudio }}
              </template>
              <template v-else-if="paciente.Internado == 'S'">
                {{ columns.row.Agendamento.LocalMarcado }}
              </template>
            </b-table-column>
            <b-table-column
              field="FormaAtendimento"
              label=" "
              :class="{
                actions: true,
                'is-hidden-mobile': !columns.row.Agendamento.TemPreparo
              }"
            >
              <div>
                <b-button
                  v-if="columns.row.Agendamento.TemPreparo"
                  @click="
                    modalPreparo(
                      columns.row.Agendamento.CodigoAtendimento,
                      true
                    )
                  "
                >
                  <span class="action-item-positive">
                    {{ $t('agenda.preparo') }}
                  </span>
                  <i class="icon-ic_alert-blue action-icon" />
                </b-button>
              </div>
            </b-table-column>
            <b-table-column field="Confirmar" label="Ações" class="actions">
              <div
                v-if="
                  columns.row.Agendamento.FormaAtendimento ===
                    FormaAtendimento.Presencial &&
                  (podeConfirmarAgendamento([columns.row]) ||
                    podeRemarcarAtendimento([columns.row]) ||
                    soPodeCancelarAtendimento([columns.row]))
                "
                class="action-container"
              >
                <div
                  v-if="parseInt(columns.row.Agendamento.CodigoAtendimento) > 0"
                  class="flex-mobile"
                >
                  <b-button
                    v-if="podeConfirmarAgendamento([columns.row])"
                    class="action-item-positive margin-mobile"
                    @click="
                      mostrarConfirmacaoAtendimentoModal(
                        true,
                        columns.row.Agendamento.CodigoAtendimento,
                        columns.row.Agendamento.TemPreparo
                      )
                    "
                  >
                    {{ $t('botoes.confirmar-atendimento') }}
                  </b-button>
                  <b-button
                    v-if="podeRemarcarAtendimento([columns.row])"
                    class="action-item-negative margin-mobile"
                    @click="
                      mostrarJustificativaAusenciaModal(
                        true,
                        false,
                        columns.row.Agendamento.CodigoAtendimento
                      )
                    "
                  >
                    {{ $t('botoes.remarcar-atendimento') }}
                  </b-button>
                  <b-button
                    v-if="soPodeCancelarAtendimento([columns.row])"
                    class="action-item-negative margin-mobile"
                    @click="
                      mostrarJustificativaAusenciaModal(
                        true,
                        false,
                        columns.row.Agendamento.CodigoAtendimento
                      )
                    "
                  >
                    {{ $t('botoes.cancelar-atendimento') }}
                  </b-button>
                </div>
                <div
                  v-if="columns.row.Agendamento.CodigoInternacao > 0"
                  class="flex-mobile"
                >
                  <b-button
                    v-if="podeConfirmarAgendamento([columns.row])"
                    class="action-item-positive margin-mobile"
                    @click="
                      mostrarConfirmacaoInternacaoModal(
                        true,
                        columns.row.Agendamento.CodigoInternacao
                      )
                    "
                  >
                    {{ $t('botoes.confirmar-atendimento') }}
                  </b-button>
                </div>
              </div>

              <a
                v-if="
                  columns.row.Agendamento.FormaAtendimento !==
                    FormaAtendimento.Presencial &&
                  columns.row.Agendamento.TpRespostaPaciente === 'C'
                "
                class="button action-item-positive"
                target="_blank"
                :href="
                  urlTeleatendimentoIniciar + columns.row.CodigoTeleatendimento
                "
              >
                <span
                  v-if="
                    columns.row.Agendamento.FormaAtendimento ===
                    FormaAtendimento.Telefone
                  "
                >
                  {{ $t('botoes.termo-consentimento') }}
                </span>
                <span
                  v-else-if="
                    columns.row.Agendamento.FormaAtendimento ===
                    FormaAtendimento.Videoconferencia
                  "
                >
                  {{ $t('botoes.iniciar-video') }}
                </span>
                <i class="icon-ic_link action-icon" />
              </a>

              <div
                v-if="
                  columns.row.Agendamento.FormaAtendimento !==
                    FormaAtendimento.Presencial &&
                  (podeConfirmarAgendamento([columns.row]) ||
                    podeRemarcarAtendimento([columns.row]) ||
                    soPodeCancelarAtendimento([columns.row]))
                "
                class="action-container"
              >
                <div class="flex-mobile">
                  <a
                    v-if="podeConfirmarAgendamento([columns.row])"
                    class="button action-item-positive margin-mobile"
                    target="_blank"
                    :href="
                      urlTeleatendimentoConfirmar +
                      columns.row.CodigoTeleatendimento
                    "
                  >
                    {{ $t('botoes.confirmar-atendimento') }}
                    <i class="icon-ic_link action-icon" />
                  </a>
                  <b-button
                    v-if="podeRemarcarAtendimento([columns.row])"
                    class="action-item-negative margin-mobile"
                    @click="
                      mostrarJustificativaAusenciaModal(
                        true,
                        false,
                        columns.row.Agendamento.CodigoAtendimento
                      )
                    "
                  >
                    {{ $t('botoes.remarcar-atendimento') }}
                  </b-button>
                  <b-button
                    v-if="soPodeCancelarAtendimento([columns.row])"
                    class="action-item-negative margin-mobile"
                    @click="
                      mostrarJustificativaAusenciaModal(
                        true,
                        false,
                        columns.row.Agendamento.CodigoAtendimento
                      )
                    "
                  >
                    {{ $t('botoes.cancelar-atendimento') }}
                  </b-button>
                </div>
              </div>
            </b-table-column>
          </template>
          <template #footer>
            <th class="is-hidden-mobile" colspan="3">
              <div class="th-wrap">
                <b-button
                  v-if="atendimentosSelecionados.length > 0"
                  class="button button-primary"
                  @click="
                    mostrarConfirmacaoAtendimentoModal(
                      true,
                      atendimentosSelecionados.map(
                        (m) => m.Agendamento.CodigoAtendimento
                      ),
                      false
                    )
                  "
                >
                  {{ $t('botoes.confirmar-atendimentos-selecionados') }}
                </b-button>
              </div>
            </th>
            <th class="is-hidden-mobile">
              <div class="th-wrap" />
            </th>
            <th class="is-hidden-mobile">
              <div class="th-wrap" />
            </th>
            <th class="is-hidden-mobile">
              <div class="th-wrap" />
            </th>
            <th v-show="exibirColunaLocal" class="is-hidden-mobile">
              <div class="th-wrap" />
            </th>
            <th class="is-hidden-mobile">
              <div class="th-wrap" />
            </th>
            <th class="is-hidden-mobile">
              <div class="th-wrap">
                <b-button
                  v-if="atendimentosConfirmar.length > 0"
                  class="button button-secondary"
                  style="padding: 0px 10px"
                  @click="
                    mostrarConfirmacaoAtendimentoModal(
                      true,
                      atendimentosConfirmar.map(
                        (m) => m.Agendamento.CodigoAtendimento
                      ),
                      false
                    )
                  "
                >
                  {{ $t('botoes.confirmar-todos') }}
                </b-button>
                <b-button
                  v-if="podeRemarcarAtendimento(ListaAgendamentos)"
                  class="button button-secondary-negative"
                  style="margin-left: 10px; padding: 0px 10px"
                  @click="
                    mostrarJustificativaAusenciaModal(
                      true,
                      false,
                      ListaAgendamentos.filter((a) =>
                        podeRemarcarAtendimento([a])
                      ).map((a) => a.Agendamento.CodigoAtendimento),
                      true
                    )
                  "
                >
                  {{ $t('botoes.remarcar-todos') }}
                </b-button>
              </div>
            </th>
          </template>
        </b-table>
      </div>
    </div>

    <absence-modal
      v-if="absenceModal"
      :toggle="absenceModal"
      @closeModal="toggleAbsenceModal()"
    />
    <preparation-modal
      v-if="mostrarModal"
      :toggle="mostrarModal"
      :dados-exames="this.getExameSelecionado"
      @closeModal="modalPreparo()"
    />
    <confirmar-atendimento-modal
      v-if="mostrarConfirmacaoAtendimento"
      :toggle="mostrarConfirmacaoAtendimento"
      :atendimentos="atendimentos"
      :mensagem="mensagemConfirmacao"
      :pode-remarcar-atendimentos="podeRemarcarAtendimentosSelecionados"
      :dados-exames="this.getExameSelecionado"
      @closeModal="onCloseConfirmacaoAtendimentoModal"
    />
    <confirmar-internacao-modal
      v-if="mostrarConfirmacaoInternacao"
      :toggle="mostrarConfirmacaoInternacao"
      :internacao="internacao"
      @closeModal="onCloseConfirmacaoInternacaoModal"
    />
    <justificar-ausencia-modal
      v-if="mostrarJustificativaAusencia"
      :toggle="mostrarJustificativaAusencia"
      :atendimentos="atendimentos"
      :habilitar-voltar="habilitarModalAusenciaVoltar"
      :is-teleatendimento="isTeleatendimentoJustificarAusencia"
      :atendimentos-remarcar="atendimentosRemarcar"
      :paciente="paciente"
      @closeModal="onCloseJustificativaAusenciaModal"
    />
    <informacao-modal
      v-if="mostrarInformacao"
      :toggle="mostrarInformacao"
      :titulo="tituloInformacao"
      :mensagem="mensagem"
      @closeModal="onCloseInformacaoModal"
    />
    <optin-modal v-if="paciente" :paciente="paciente" />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router'
import Breadcrumb from '../components/shared/breadcrumb/Breadcrumb'
import AbsenceModal from '@/components/shared/modal/AbsenceModal'
import PreparationModal from '@/components/shared/modal/PreparationModal'
import { FormaAtendimento } from '../mixins/forma-atendimento'
import { NotAuthenticatedError } from '../models/not-authenticated-error'
import ConfirmarAtendimentoModal from '../components/shared/modal/ConfirmarAtendimentoModal.vue'
import ConfirmarInternacaoModal from '../components/shared/modal/ConfirmarInternacaoModal.vue'
import JustificarAusenciaModal from '../components/shared/modal/JustificarAusenciaModal'
import InformacaoModal from '../components/shared/modal/InformacaoModal.vue'
import OptinModal from '../components/shared/modal/OptinModal.vue'

export default {
  name: 'AgendaView',
  components: {
    Breadcrumb,
    AbsenceModal,
    PreparationModal,
    ConfirmarAtendimentoModal,
    ConfirmarInternacaoModal,
    JustificarAusenciaModal,
    InformacaoModal,
    OptinModal
  },

  data() {
    return {
      atendimentos: [],
      internacao: null,
      mostrarConfirmacaoAtendimento: false,
      mostrarConfirmacaoInternacao: false,
      mostrarJustificativaAusencia: false,
      habilitarModalAusenciaVoltar: undefined,
      isTeleatendimentoJustificarAusencia: undefined,
      mensagemConfirmacao: '',
      mostrarInformacao: false,
      tituloInformacao: this.$t('labels.informacao'),
      mensagem: '',
      mostrarModal: false,
      absenceModal: false,
      isPaginated: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 10,
      FormaAtendimento: FormaAtendimento,
      urlTeleatendimentoConfirmar:
        process.env.VUE_APP_TELEATENDIMENTO_CONFIRMAR,
      urlTeleatendimentoIniciar: process.env.VUE_APP_TELEATENDIMENTO_INICIAR,
      atendimentosSelecionados: [],
      remarcarTodos: false,
      podeRemarcarAtendimentosSelecionados: false,
      diaDaSemana: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sat'],
      exibirColunaLocal: false
    }
  },

  computed: {
    ...mapGetters({
      ListaAgendamentos: 'Agendamentos',
      isLoading: 'isLoading',
      getExameSelecionado: 'ExameSelecionado',
      paciente: 'dadosPaciente'
    }),
    atendimentosConfirmar() {
      return this.ListaAgendamentos.filter(
        (a) =>
          this.podeConfirmarAgendamento([a]) &&
          a.Agendamento.FormaAtendimento === FormaAtendimento.Presencial &&
          a.Agendamento.CodigoAtendimento > 0
      )
    },
    atendimentosRemarcar() {
      if (this.remarcarTodos) {
        return this.atendimentosConfirmar
      } else {
        return this.ListaAgendamentos.filter(function (item) {
          return item.Agendamento.SituacaoAtendimento === 'M'
        })
      }
    }
  },

  beforeMount() {
    this.VerificarUsuario()
  },

  mounted() {
    this.getAgendamentos()
      .catch((err) => {
        if (err instanceof NotAuthenticatedError) router.push('/')
      })
      .finally(() => {
        this.exibirColunaLocal =
          this.ListaAgendamentos.some(
            (a) => !!a.Agendamento.LocalChamadaAudio
          ) ||
          (this.paciente?.Internado === 'S' &&
            this.ListaAgendamentos.some((a) => !!a.Agendamento.LocalMarcado))
      })
  },

  methods: {
    ...mapActions(['getAgendamentos', 'getDadosExame']),
    VerificarUsuario() {
      if (this.paciente == null) {
        router.push({ path: '/', query: { returnUrl: this.$route.path } })
      }
    },
    modalPreparo(codigoAtendimento, temPreparo) {
      if (temPreparo) {
        this.getDadosExame(codigoAtendimento).then(() => {
          this.mostrarModal = !this.mostrarModal
        })
      } else {
        this.mostrarModal = false
      }
    },
    getTags(row) {
      return [
        {
          type: 'is-info',
          show: row.Agendamento.TpRespostaPaciente === 'C',
          label: 'Confirmado'
        },
        {
          type: 'is-warning',
          show: this.isAguardandoRemarcacao(row.Agendamento),
          label: 'Aguardando remarcação'
        },
        {
          type: 'is-warning',
          show: this.isAguardandoCancelamento(row.Agendamento),
          label: 'Aguardando cancelamento'
        }
      ].filter((e) => e.show)
    },

    toggleAbsenceModal() {
      this.absenceModal = !this.absenceModal
    },
    async mostrarConfirmacaoAtendimentoModal(mostrar, codigos, temPreparo) {
      const unicoCodigo = !Array.isArray(codigos)

      this.atendimentos = unicoCodigo ? [codigos] : codigos
      this.podeRemarcarAtendimentosSelecionados = this.podeRemarcarAtendimento(
        this.atendimentosConfirmar
      )
      this.mensagemConfirmacao =
        this.atendimentos.length > 1
          ? this.$t('agenda.confirmar-multiplos')
          : this.$t('agenda.confirmar-orientacao')

      try {
        if (unicoCodigo && temPreparo) {
          await this.getDadosExame(codigos)
        } else {
          await this.getDadosExame()
        }
      } catch (err) {
        if (err instanceof NotAuthenticatedError) router.push('/')
      }

      this.mostrarConfirmacaoAtendimento = mostrar
    },
    async mostrarConfirmacaoInternacaoModal(mostrar, codigoInternacao) {
      this.internacao = codigoInternacao
      this.mostrarConfirmacaoInternacao = mostrar
    },
    podeConfirmarAgendamento(eventos) {
      const isEventoConfirmavel = (e) =>
        /* FEATURE_FLAG: cds_unidade para confirmação de internação */
        (this.paciente &&
          [1, 2, 4, 5, 7, 11].includes(this.paciente.CodigoUnidade) &&
          e.Agendamento.CodigoInternacao > 0 &&
          e.Agendamento.TpRespostaPaciente === null) ||
        (parseInt(e.Agendamento.CodigoAtendimento) > 0 &&
          e.Agendamento.SituacaoAtendimento === 'M' &&
          e.Agendamento.CodigoAtendimento !== 0 &&
          e.Agendamento.TpRespostaPaciente === null)
      return eventos.some(isEventoConfirmavel)
    },
    podeRemarcarAtendimento(eventos) {
      const consultasBloqueios = [
        'INTERNAÇÃO',
        'REVISÃO ANESTÉSICA',
        'ENFERMAGEM - RISCO CIRÚRGICO',
        'RISCO CIRÚRGICO ADULTO',
        'RISCO CIRÚRGICO INFANTIL'
      ]

      const filterBloqueioFn = (a) =>
        consultasBloqueios.some((c) =>
          a.Agendamento.Descricao.toUpperCase().includes(c)
        )
      const bloqueios = this.ListaAgendamentos.filter(filterBloqueioFn)
      const isEventoRemarcavel = (e) =>
        e.Agendamento.CodigoAtendimento > 0 &&
        e.Agendamento.SituacaoAtendimento === 'M' &&
        !['A', 'D'].includes(e.Agendamento.TpRespostaPaciente) &&
        e.Agendamento.LimiteRemarcacaoPaciente -
          e.Agendamento.QuantidadeRemarcacoesPaciente >
          0
      const isProximoBloqueio = eventos.some((e) =>
        bloqueios.some((i) => {
          let dataLimiteInternacao = new Date(i.Agendamento.Data)
          dataLimiteInternacao.setDate(dataLimiteInternacao.getDate() - 7)
          return new Date(e.Agendamento.Data) >= dataLimiteInternacao
        })
      )

      return (
        this.paciente &&
        this.paciente.Internado === 'N' &&
        eventos.some(isEventoRemarcavel) &&
        !isProximoBloqueio
      )
    },
    soPodeCancelarAtendimento(eventos) {
      const consultasBloqueios = [
        'INTERNAÇÃO',
        'REVISÃO ANESTÉSICA',
        'ENFERMAGEM - RISCO CIRÚRGICO',
        'RISCO CIRÚRGICO ADULTO',
        'RISCO CIRÚRGICO INFANTIL'
      ]
      const filterBloqueioFn = (a) =>
        consultasBloqueios.some((c) =>
          a.Agendamento.Descricao.toUpperCase().includes(c)
        )
      const bloqueios = this.ListaAgendamentos.filter(filterBloqueioFn)
      const isEventoSoCancelavel = (e) =>
        e.Agendamento.CodigoAtendimento > 0 &&
        e.Agendamento.SituacaoAtendimento === 'M' &&
        !['A', 'D'].includes(e.Agendamento.TpRespostaPaciente) &&
        e.Agendamento.LimiteRemarcacaoPaciente ===
          e.Agendamento.QuantidadeRemarcacoesPaciente
      const isProximoBloqueio = eventos.some((e) =>
        bloqueios.some((i) => {
          let dataLimiteInternacao = new Date(i.Agendamento.Data)
          dataLimiteInternacao.setDate(dataLimiteInternacao.getDate() - 7)
          return new Date(e.Agendamento.Data) >= dataLimiteInternacao
        })
      )

      return (
        this.paciente &&
        this.paciente.Internado === 'N' &&
        [2, 4, 5, 7, 11, 14, 17, 18, 19, 20].includes(
          this.paciente.CodigoUnidade
        ) &&
        eventos.some(isEventoSoCancelavel) &&
        !isProximoBloqueio
      )
    },
    mostrarJustificativaAusenciaModal(
      mostrar,
      bVoltar,
      codigos,
      remarcarTodos = false
    ) {
      this.atendimentos = Array.isArray(codigos) ? codigos : [codigos]
      this.mostrarJustificativaAusencia = mostrar
      this.habilitarModalAusenciaVoltar = bVoltar
      this.remarcarTodos = remarcarTodos
      const filterFn = (a) =>
        a.Agendamento &&
        a.Agendamento.FormaAtendimento !== FormaAtendimento.Presencial &&
        this.atendimentos.includes(a.Agendamento.CodigoAtendimento)
      this.isTeleatendimentoJustificarAusencia =
        this.ListaAgendamentos.filter(filterFn).length > 0
    },
    mostrarInformacaoModal(mostrar, mensagem) {
      this.mensagem = mensagem
      this.mostrarInformacao = mostrar
    },
    onCloseConfirmacaoAtendimentoModal(resultado) {
      this.mostrarConfirmacaoAtendimentoModal(false)
      if (resultado === 'confirmado') {
        this.mostrarInformacaoModal(
          true,
          this.$t('agenda.mensagem-confirmacao')
        )
        this.getAgendamentos()
          .then(() => {
            this.atendimentosSelecionados = []
          })
          .catch((err) => {
            if (err instanceof NotAuthenticatedError) router.push('/')
          })
      } else if (resultado === 'justificarAusencia') {
        const selecionadosFn = (a) =>
          this.atendimentos.includes(a.Agendamento.CodigoAtendimento)
        const atendimentosSelecionados =
          this.ListaAgendamentos.filter(selecionadosFn)
        this.atendimentos = atendimentosSelecionados
          .filter((a) => this.podeRemarcarAtendimento([a]))
          .map((a) => a.Agendamento.CodigoAtendimento)

        this.mostrarJustificativaAusenciaModal(true, true, this.atendimentos)
      } else if (resultado === 'chat') {
        this.mostrarInformacaoModal(true, this.$t('agenda.ausencia-orientacao'))
        window.open('http://www.sarah.br/chat')
      }
    },
    onCloseConfirmacaoInternacaoModal(resultado) {
      this.mostrarConfirmacaoInternacaoModal(false)
      if (resultado === 'confirmado') {
        this.mostrarInformacaoModal(
          true,
          this.$t('agenda.confirmar-internacao.confirmada')
        )
        this.getAgendamentos()
          .then(() => {
            this.atendimentosSelecionados = []
          })
          .catch((err) => {
            if (err instanceof NotAuthenticatedError) router.push('/')
          })
      }
    },
    enumerarTexto(lista) {
      if (lista.length === 0) return ''
      if (lista.length === 1) return lista[0]
      if (lista.length === 2) return lista.join(' e ')

      const todosMenosUltimo = lista.slice(0, -1).join(', ')
      const ultimo = lista[lista.length - 1]
      return `${todosMenosUltimo} e ${ultimo}`
    },
    onCloseJustificativaAusenciaModal(resultado, motivo) {
      this.mostrarJustificativaAusencia = false
      if (resultado === 'voltar') {
        this.mostrarConfirmacaoAtendimentoModal(
          true,
          this.atendimentosConfirmar.map(
            (m) => m.Agendamento.CodigoAtendimento
          ),
          false
        )
      } else if (resultado === 'cancelar') {
        this.mostrarJustificativaAusenciaModal(false, false, this.atendimentos)
      } else if (resultado === 'confirmado') {
        let texto = ''
        if (motivo === '4') {
          texto = this.$t('agenda.justificar-ausencia.confirmacaoCancelamento')

          const filterSelecionadosFn = (a) =>
            a.Agendamento &&
            this.atendimentos.includes(a.Agendamento.CodigoAtendimento)
          const agendamentosSelecionados =
            this.ListaAgendamentos.filter(filterSelecionadosFn)

          if (
            agendamentosSelecionados.some(
              (e) => e.Agendamento.LimiteRemarcacaoPaciente === 0
            )
          ) {
            texto += this.$t(
              'agenda.justificar-ausencia.confirmacaoCancelamentoSemRemarcacoes'
            )
          }
        } else {
          texto = this.$t(
            'agenda.justificar-ausencia.confirmacaoRemarcacaoInicio'
          )

          const filterSelecionadosFn = (a) =>
            a.Agendamento &&
            this.atendimentos.includes(a.Agendamento.CodigoAtendimento)
          const agendamentosSelecionados =
            this.ListaAgendamentos.filter(filterSelecionadosFn)

          const filterUltimosAgendamentos = (e) =>
            e.Agendamento.LimiteRemarcacaoPaciente <=
            e.Agendamento.QuantidadeRemarcacoesPaciente + 1
          const agendamentosUltimos = agendamentosSelecionados.filter(
            filterUltimosAgendamentos
          )

          if (agendamentosUltimos.length === 1) {
            texto += ` ${this.$t(
              'agenda.justificar-ausencia.confirmacaoRemarcacaoAvisoUltimaSingular'
            )} "${agendamentosUltimos[0].Agendamento.Descricao}".`
          } else if (agendamentosUltimos.length > 1) {
            const mapFn = (e) => e.Agendamento.Descricao
            const descricaoAgendamentosUltimos = this.enumerarTexto(
              agendamentosUltimos.map(mapFn)
            )
            texto += ` ${this.$t(
              'agenda.justificar-ausencia.confirmacaoRemarcacaoAvisoUltimaPlural'
            )} ${descricaoAgendamentosUltimos}.`
          }
          texto += ` ${this.$t(
            'agenda.justificar-ausencia.confirmacaoRemarcacaoFim'
          )} ${this.$t('agenda.justificar-ausencia.confirmacaoRemarcacao2')}`
        }

        this.mostrarInformacaoModal(true, texto)
        this.getAgendamentos()
          .then(() => {
            this.atendimentosSelecionados = []
          })
          .catch((err) => {
            if (err instanceof NotAuthenticatedError) router.push('/')
          })
      }
    },
    onCloseInformacaoModal() {
      this.mostrarInformacao = false
    },
    textoObservacao(formaAtendimento) {
      switch (formaAtendimento) {
        case FormaAtendimento.Videoconferencia:
          return this.$t('agenda.video')
        case FormaAtendimento.Telefone:
          return this.$t('agenda.telefone')
        default:
          return this.$t('agenda.presencial')
      }
    },
    isAguardandoRemarcacao(agendamento) {
      return (
        agendamento.DataMarcacao &&
        agendamento.DataRespostaPaciente &&
        agendamento.TpRespostaPaciente === 'A' &&
        new Date(agendamento.DataRespostaPaciente) >
          new Date(agendamento.DataMarcacao)
      )
    },
    isAguardandoCancelamento(agendamento) {
      return (
        agendamento.DataMarcacao &&
        agendamento.DataRespostaPaciente &&
        agendamento.TpRespostaPaciente === 'D' &&
        new Date(agendamento.DataRespostaPaciente) >
          new Date(agendamento.DataMarcacao)
      )
    }
  }
}
</script>

<style lang="scss" src="@/assets/stylesheets/views/Agenda.scss"></style>
